import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { UniqueMechanism } from './components/UniqueMechanism';
import { SessionBenefits } from './components/SessionBenefits';
import { Testimonials } from './components/Testimonials';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const win = window as any;
    if (!win.fbq) {
      const n = win.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!win._fbq) win._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    win.fbq('init', '1564311555289232');
    win.fbq('track', 'PageView');
    // Track clicks on agenda buttons
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const text = target?.innerText?.trim();
      const href = (target as HTMLAnchorElement)?.href || '';
      if (text === 'AGENDA TU SESIÓN AQUÍ' || text === 'AGENDAR MI ASESORÍA DE BLINDAJE' || href.includes('calendly.com')) {
        win.fbq('track', 'Schedule');
      }
    };
    document.addEventListener('click', handleClick, true);
    // Noscript pixel fallback
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1564311555289232&ev=PageView&noscript=1';
    document.body.appendChild(img);
    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, []);
  return <div className="min-h-screen bg-navy text-white font-inter selection:bg-gold selection:text-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <FailedAttempts data-id="element-4" />
      <UniqueMechanism data-id="element-5" />
      <SessionBenefits data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Audience data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <FAQ data-id="element-10" />
      <CTA data-id="element-11" />
      <Footer data-id="element-12" />

      <footer className="bg-navy py-8 border-t border-white/5 text-center text-gray-dark text-sm" data-id="element-13">
        <div className="max-w-5xl mx-auto px-6" data-id="element-14">
          <p data-id="element-15">
            © {new Date().getFullYear()} El Protocolo del Retiro Blindado.
            Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}